<div class="row">
  <div class="col-12">
    <browse-products
      (objProductSelected)="addLineItem($event)"
      [customerId]="customerId"
      [bHasAssetType]="true"
    >
    </browse-products>
  </div>
  <div class="col-12 mb-3">
    <div class="mt-3">
      <table class="table border rounded" id="line_items">
        <thead>
          <tr>
            <th scope="col" width="6%"></th>
            <th scope="col" style="font-size: 12px;">{{ 'description' | translate }}</th>
            <th scope="col" *ngIf="bDepartmentTracking" width="12%" style="font-size: 12px;">{{ 'department' | translate }}<required-tag></required-tag></th>
            <th scope="col" width="10%" style="font-size: 12px;">{{ 'quantity' | translate }}</th>
            <th scope="col" width="10%" style="font-size: 12px;">{{ 'unit_price' | translate }}</th>
            <th scope="col" width="14%" style="font-size: 12px;">{{ 'tax_code' | translate }}<required-tag></required-tag></th>
            <th scope="col" width="14%" style="font-size: 12px;">{{ 'account_code' | translate }}<required-tag></required-tag></th>
            <th scope="col" width="10%" style="font-size: 12px;">{{ 'amount' | translate }}</th>
          </tr>
        </thead>

        <tbody>
          <!-- per line item -->
          <ng-container
            *ngFor="let objLineItem of arLineItems; let intIndex = index"
          >
            <tr
              [ngClass]="{
                'multiple-selected': contextMenuService.isLineItemSelected(objLineItem, selectedLineItems),
                'row-focused': (focusedLineIndex - 1) == intIndex
              }"
              (click)="onLineFocus(intIndex)"
            >
              <td
                [shAttachMenu]="contextMenuComponent?.menu"
                [shMenuData]="contextMenuService.formatMenuData(objLineItem, intIndex)"
                (click)="onClickedLineItem($event, objLineItem)"
                matTooltip="{{ 'copy_paste_info' | translate }}"
                matTooltipPosition="right"
              >
                <div class="d-flex justify-content-center">
                  <fa-icon *ngIf="arLineItems.length > 1" (click)="removeLineItem(intIndex)"
                    class="pl-1 pr-1 pb-2 pt-2 text-danger pointer"
                    [icon]="['fal', 'minus-circle']">
                  </fa-icon>

                  <a *ngIf="objLineItem.objItem && objLineItem.objItem['id']"
                    href="/#/items/{{ objLineItem.objItem['id'] }}"
                    class="pl-1 pr-1 pb-2 pt-2"
                    target="_blank">
                    <fa-icon
                      matTooltipClass="tooltip-space"
                      matTooltip="
                      {{ 'click_to_view' | translate }}&#13;&#13;
                      {{ 'product' | translate }}: {{ objLineItem.objItem['text'] }}&#13;
                      {{ 'code' | translate }}: {{ objLineItem.objItem['code'] | placeholdWithString }}&#13;
                      "
                      class="pointer text-primary"
                      [icon]="['fas', 'info-circle']">
                    </fa-icon>
                  </a>
                  <fa-icon
                    *ngIf="!objLineItem.objItem || objLineItem.objItem && !objLineItem.objItem.id"
                    class="pl-1 pr-1 pb-2 pt-2 text-success pointer"
                    matTooltip="{{ 'create_item' | translate }}"
                    [icon]="['fas', 'plus-circle']"
                    (click)="createItem(objLineItem)">
                  </fa-icon>
                </div>
              </td>
              <td>
                <textarea
                  [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="objLineItem.description"
                  class="form-control description"
                  style="font-size: 12px;"
                  placeholder="{{ 'description' | translate }}"
                  (change)="updateLineItems()"
                ></textarea>
              </td>
              <td *ngIf="bDepartmentTracking">
                <ng-select
                  [items]="objLineItem._arSelectableDepartments$ | async"
                  [loading]="objLineItem._bIsLoadingDepartments"
                  [typeahead]="objLineItem._objDepartmentTypeahead$"
                  [hideSelected]="true"
                  [clearable]="true"
                  [ngModelOptions]="{standalone: true}"
                  [bindValue]
                  [(ngModel)]="objLineItem.objDepartment"
                  [class.is-invalid]="objDepartment.touched && ! objDepartment.valid"
                  #objDepartment="ngModel"
                  [required]="bDepartmentTracking"
                  bindLabel="text"
                  placeholder="{{ 'select_department' | translate }}"
                  (open)="objLineItem._objDepartmentTypeahead$.next('')"
                  (change)="updateLineItems()">
                  <!-- DISPLAY IN SELECTED -->
                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-label">{{ item.text | translate }}</span>
                  </ng-template>
                  <!-- DISPLAY IN OPTION -->
                  <ng-template  ng-option-tmp let-item="item">
                    <span class="value-text"> {{ item.text | translate }}</span>
                  </ng-template>
                </ng-select>
              </td>
              <td>
                <fieldmagic-decimal-input
                  [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="objLineItem.quantity"
                  (change)="calculateAmount(objLineItem)"
                  customClass="form-control font-size-12"
                  placeholder="{{ 'quantity' | translate }}">
                </fieldmagic-decimal-input>
              </td>
              <td>
                <fc-currency-input
                  [places]="4"
                  id="unit_price_{{ intIndex }}"
                  [(ngModel)]="objLineItem.unitPrice"
                  [ngModelOptions]="{standalone: true}"
                  [nonNegative]="false"
                  [customClass]="'form-control font-size-12'"
                  (change)="calculateAmount(objLineItem)"
                >
                </fc-currency-input>
              </td>
              <td>
                <ng-select
                  [items]="objLineItem._arSelectableTaxCodes$ | async"
                  [loading]="objLineItem._bIsLoadingTaxCodes"
                  [typeahead]="objLineItem._objTaxCodeTypeahead$"
                  [hideSelected]="true"
                  [clearable]="true"
                  [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="objLineItem.objTaxCode"
                  [bindValue]
                  [class.is-invalid]="objTaxCode.touched && ! objTaxCode.valid"
                  #objTaxCode="ngModel"
                  required
                  bindLabel="text"
                  placeholder="{{ 'tax_code' | translate }}"
                  (open)="objLineItem._objTaxCodeTypeahead$.next('')"
                  (change)="calculateAmount(objLineItem)"
                >
                  <!-- DISPLAY IN SELECTED -->
                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-label">{{ item.text | translate }}</span>
                  </ng-template>
                  <!-- DISPLAY IN OPTION -->
                  <ng-template  ng-option-tmp let-item="item">
                    <span class="value-text"> {{ item.text | translate }}</span>
                  </ng-template>
                </ng-select>
              </td>
              <td>
                <ng-select
                  [items]="objLineItem._arSelectableAccountCodes$ | async"
                  [loading]="objLineItem._bIsLoadingAccountCodes"
                  [typeahead]="objLineItem._objAccountCodeTypeahead$"
                  [hideSelected]="true"
                  [clearable]="true"
                  [ngModelOptions]="{standalone: true}"
                  [bindValue]
                  [class.is-invalid]="objAccountCode.touched && ! objAccountCode.valid"
                  #objAccountCode="ngModel"
                  required
                  [(ngModel)]="objLineItem.objAccountCode"
                  bindLabel="text"
                  placeholder="{{ 'account_code' | translate }}"
                  (open)="objLineItem._objAccountCodeTypeahead$.next('')"
                  (change)="calculateAmount(objLineItem)"
                >
                  <!-- DISPLAY IN SELECTED -->
                  <ng-template ng-label-tmp let-item="item" let-clear="clear">
                    <span class="ng-value-label">{{ item.text | translate }}</span>
                  </ng-template>
                  <!-- DISPLAY IN OPTION -->
                  <ng-template  ng-option-tmp let-item="item">
                    <span class="value-text"> {{ item.text | translate }}</span>
                  </ng-template>
                </ng-select>
              </td>
              <td>
                <fc-currency-input
                  customClass="form-control font-size-12 input-height-40"
                  [(ngModel)]="objLineItem.amount"
                  [ngModelOptions]="{standalone: true}"
                  (change)="onLineTotalChange($event.target, {line: objLineItem})"
                ></fc-currency-input>
              </td>
              <!-- /end remove line -->
            </tr>
          </ng-container>
          <!-- /end per line item -->

          <!-- no invoice content -->
          <tr *ngIf="arLineItems.length < 1" [shAttachMenu]="contextMenuComponent?.menu" [shMenuData]="contextMenuService.formatMenuData([], -1)">
            <td class="text-center" colspan="9">
              <span>{{ 'no_invoice_line' | translate }}</span>
            </td>
          </tr>
          <!-- /end no invoice content -->

        </tbody>
      </table>
    </div>

    <!-- Total Computation -->
    <div class="mt-1">
      <table class="table">
        <tbody>
          <tr class="border">
            <th scope="row" width="70%" class="invisible"></th>
            <td scope="row" width="15%"><span class="p-2 float-right">{{ 'total_ex_tax' | translate }}</span></td>
            <td scope="row" width="15%" class="text-center">
              <fc-currency-input
                id="invoiceLineIncludedTaxField"
                [(ngModel)]="fltTotalIncludedTaxAmount"
                [ngModelOptions]="{standalone: true}"
                customClass="form-control input-height-40 font-size-12"
                (change)="onGrandTotalChange($event.target)"
              >
              </fc-currency-input>
            </td>
          </tr>
          <tr class="border">
            <th scope="row" class="invisible"></th>
            <td scope="row"><span class="p-2 float-right">{{ 'tax' | translate }}</span> </td>
            <td scope="row" class="text-center">
              <span class="p-2 form-group" matTooltip="{{ fltTotalTaxAmount | currency }}">{{ fltTotalTaxAmount | currency: {decimal_places: 2} }}</span>
            </td>
          </tr>
          <tr class="border">
            <th scope="row" class="invisible"></th>
            <td scope="row"><span class="p-2 float-right">{{ 'tax_adjustment_amount' | translate }}</span> </td>
            <td scope="row" class="text-center">
              <fc-currency-input
                step="0.01"
                [withControls]="true"
                customClass="form-control font-size-12 input-height-40"
                [(ngModel)]="totalTaxAdjustment"
                [ngModelOptions]="{standalone: true}"
                (change)="onTaxAdjustment($event.target)"
              ></fc-currency-input>
            </td>
          </tr>
          <tr class="border">
            <th scope="row" class="invisible"></th>
            <td scope="row"><span class="p-2 float-right">{{ 'total_inc_tax' | translate }}</span> </td>
            <td scope="row" class="text-center">
              <fc-currency-input
                id="invoiceLineIncludedTaxField"
                [(ngModel)]="fltTotalIncludedTaxAmount"
                [ngModelOptions]="{standalone: true}"
                customClass="form-control input-height-40 font-size-12"
                (change)="onGrandTotalChange($event.target)"
              >
              </fc-currency-input>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>